import { render, staticRenderFns } from "./add-course-work.vue?vue&type=template&id=f363de0e"
import script from "./add-course-work.vue?vue&type=script&lang=ts&setup=true"
export * from "./add-course-work.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./add-course-work.vue?vue&type=style&index=0&id=f363de0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports